module.exports = __webpack_public_path__ + "files/2804cc702eaf315f2b9e8334e8ce1231.svg";